import { exportHtml } from "@api/stores/purchaseInvoices/exportHtml/api";
import { exportPDF } from "@api/stores/purchaseInvoices/exportPDF/api";
import { items } from "@api/stores/purchaseInvoices/items/api";
import { payments } from "@api/stores/purchaseInvoices/payments/api";
import { returns } from "@api/stores/purchaseInvoices/returns/api";
import { stats } from "@api/stores/purchaseInvoices/stats/api";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type {
  IPathBaseParam,
  IPathByIdParam,
} from "@api/stores/purchaseInvoices/path";
import type {
  IPurchaseInvoicesDto,
  IPurchaseInvoicesGetAllParams,
  IPurchaseInvoicesResponse,
} from "@api/stores/purchaseInvoices/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicesResponse>>,
  IPathBaseParam,
  IPaginationParams & IPurchaseInvoicesGetAllParams
>("stores.purchaseInvoices");
const postApis = createPostApi<
  IApiResponse<IPurchaseInvoicesResponse>,
  IPathBaseParam,
  IPurchaseInvoicesDto
>("stores.purchaseInvoices");
const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicesResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoices");
const deleteApis = createDeleteApi<
  IApiResponse<IPurchaseInvoicesResponse>,
  IPathByIdParam
>("stores.purchaseInvoices");

export const purchaseInvoices = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...deleteApis,
  stats,
  returns,
  items,
  exportHtml,
  exportPDF,
  payments,
};
